export default __webpack_public_path__ + "static/media/FAC2.95d58972.jpg";